import styled from 'styled-components'

type Props = {
	isFocused?: boolean
	isDisabled?: boolean
	hasError?: boolean
}

export const Label = styled.label<Props>`
	display: block;
	position: relative;
	margin-bottom: 4px;
	z-index: 1;
	transition: color 0.2s ease;
	text-align: left;
	opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
	color: ${({ hasError, isFocused, theme }) => {
		if (hasError) {
			return theme.color.danger
		}
		if (isFocused) {
			return theme.color.input.label
		}
		return theme.color.text
	}};
`
